		let data = {table_headers: [], data: []};
        data.module = {id: 'cmp', display: 'Compliance Monitoring Programme'}
		data.table_headers = [
            {
                accessor: "activity", nickname: "Activity", type: "alpha", width: 1.77,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            },
            {
                accessor: "risk_area", nickname: "Risk Areas", type: "alpha", width: 1.59,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            },
            {
                accessor: "subcat_name", nickname: "Subcategory", type: "alpha", width: 1.65,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            },
            {
                accessor: "company", nickname: "Company", type: "alpha", width: 1,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            },
            {
                accessor: "assigned_to", nickname: "Assigned To", type: "alpha", width: 1.06,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            },
            {
                accessor: "due_date", nickname: "Due Date", type: "date", width: 0.67,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':false,'hcentred':true, 'right':false}
            },
            {
                accessor: "colorwise_text", nickname: "Status", type: "alpha", width: 0.8,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            }
        ];    

        data.sortby = {
            fields: [
                {accessor: "activity", nickname: "Activity", type: "alpha", width: 1.2},
                {accessor: "risk_area", nickname: "Risk Areas", type: "alpha", width: 1.3},
                {accessor: "subcat_name", nickname: "Subcategory", type: "alpha", width: 1.5},
                {accessor: "company", nickname: "Company", type: "alpha", width: 1.5},
                {accessor: "assigned_to", nickname: "Assigned To", type: "alpha", width: 1.4},
                {accessor: "due_date", nickname: "Due Date", type: "date", width: 0.8},
                {accessor: "colorwise_text", nickname: "Status", type: "alpha", width: 0.8}
            ],
            selected: {"accessor": "none", "order": "Descending"}
        };
        data.groupby = {
            fields: [
                {accessor: "activity", nickname: "Activity", type: "alpha", width: 1.2},
                {accessor: "risk_area", nickname: "Risk Areas", type: "alpha", width: 1.3},
                {accessor: "subcat_name", nickname: "Subcategory", type: "alpha", width: 1.5},
                {accessor: "company", nickname: "Company", type: "alpha", width: 1.5},
                {accessor: "assigned_to", nickname: "Assigned To", type: "alpha", width: 1.4},
                {accessor: "due_date", nickname: "Due Date", type: "date", width: 0.8},
                {accessor: "colorwise_text", nickname: "Status", type: "alpha", width: 0.8}
            ],
            selections: []
        };
        data.font_size_map = {
            section_titles :    {default : {selected : false, size : 16}, small : {selected : false, size : 14}, large : {selected : true, size : 18}},
            introductory_text : {default : {selected : false, size : 12}, small : {selected : false, size : 11}, large : {selected : true, size : 14}},
            header_row_text :   {default : {selected : true, size : 12}, small : {selected : false, size : 11}, large : {selected : false, size : 14}},
            table_data_text :   {default : {selected : false, size : 11}, small : {selected : true, size : 10}, large : {selected : false, size : 12}},       
            footer:             {default : {selected : true, size : 10}, small : {selected : false, size : 9}, large : {selected : false, size : 11}}
        }

module.exports = data